var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "end-kanban-board" },
    [
      _c("div", { staticClass: "header-section" }, [
        _c("div", { staticClass: "page-title" }, [
          _c("h2", [_vm._v("末端揽收看板")]),
          _c("span", { staticClass: "subtitle" }, [
            _vm._v(
              "Atualizado: " + _vm._s(_vm.updateTime) + " (Horário de Brasília)"
            ),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "filter-section" },
          [
            _c(
              "el-radio-group",
              {
                staticStyle: { "margin-right": "15px" },
                attrs: { size: "small" },
                model: {
                  value: _vm.filter.period,
                  callback: function ($$v) {
                    _vm.$set(_vm.filter, "period", $$v)
                  },
                  expression: "filter.period",
                },
              },
              [
                _c("el-radio-button", { attrs: { label: "yesterday" } }, [
                  _vm._v("昨日"),
                ]),
                _c("el-radio-button", { attrs: { label: "today" } }, [
                  _vm._v("今日"),
                ]),
                _c("el-radio-button", { attrs: { label: "month" } }, [
                  _vm._v("本月"),
                ]),
                _c("el-radio-button", { attrs: { label: "lastMonth" } }, [
                  _vm._v("上月"),
                ]),
              ],
              1
            ),
            _c("el-date-picker", {
              staticStyle: { width: "240px", "margin-right": "10px" },
              attrs: {
                type: "daterange",
                size: "small",
                "range-separator": "—",
                "start-placeholder": "开始日期",
                "end-placeholder": "结束日期",
              },
              model: {
                value: _vm.filter.dateRange,
                callback: function ($$v) {
                  _vm.$set(_vm.filter, "dateRange", $$v)
                },
                expression: "filter.dateRange",
              },
            }),
            _c(
              "el-select",
              {
                staticStyle: { width: "150px", "margin-right": "10px" },
                attrs: {
                  placeholder: "州",
                  multiple: "",
                  "collapse-tags": "",
                  clearable: "",
                  size: "small",
                },
                model: {
                  value: _vm.filter.stateList,
                  callback: function ($$v) {
                    _vm.$set(_vm.filter, "stateList", $$v)
                  },
                  expression: "filter.stateList",
                },
              },
              _vm._l(_vm.stateOptions, function (item) {
                return _c("el-option", {
                  key: item.value,
                  attrs: { label: item.label, value: item.value },
                })
              }),
              1
            ),
            _c("el-select-v2", {
              staticStyle: { width: "200px", "margin-right": "10px" },
              attrs: {
                options: _vm.customerList,
                placeholder: "客户",
                multiple: "",
                "collapse-tags": "",
                clearable: "",
                filterable: "",
                loading: _vm.isLoadingCustomer,
                size: "small",
              },
              model: {
                value: _vm.filter.customerNameList,
                callback: function ($$v) {
                  _vm.$set(_vm.filter, "customerNameList", $$v)
                },
                expression: "filter.customerNameList",
              },
            }),
            _c("el-button", {
              attrs: { type: "primary", icon: "el-icon-search", size: "small" },
              on: { click: _vm.handleSearch },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "metrics-container" },
        [
          _c(
            "el-card",
            { staticClass: "metric-card", attrs: { shadow: "hover" } },
            [
              _c(
                "div",
                {
                  staticClass: "card-header",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [_c("span", [_vm._v("日环比 Comparativo diario")])]
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                _vm._l(_vm.metrics, function (card, index) {
                  return _c("el-col", { key: index, attrs: { span: 6 } }, [
                    _c("div", { staticClass: "metric-content" }, [
                      card.bgColor
                        ? _c("div", {
                            staticClass: "metric-corner",
                            style: { backgroundColor: card.bgColor },
                          })
                        : _vm._e(),
                      _c("div", { staticClass: "metric-info" }, [
                        _c("div", { staticClass: "metric-label" }, [
                          _vm._v(" " + _vm._s(card.label) + " "),
                          _c("span", { staticClass: "metric-sublabel" }, [
                            _vm._v("(" + _vm._s(card.subLabel) + ")"),
                          ]),
                        ]),
                        _c("div", { staticClass: "metric-value" }, [
                          _vm._v(_vm._s(card.value)),
                        ]),
                        card.diff !== undefined
                          ? _c("div", { staticClass: "metric-trend" }, [
                              _c("img", {
                                staticClass: "trend-icon",
                                attrs: {
                                  src: _vm.getTrendIcon(card.diff),
                                  alt: "trend",
                                },
                              }),
                              _c(
                                "span",
                                { class: _vm.getTrendTextClass(card.diff) },
                                [
                                  _vm._v(
                                    _vm._s(Math.abs(card.diff).toFixed(2)) + "%"
                                  ),
                                ]
                              ),
                            ])
                          : _c("div", { staticClass: "metric-trend" }),
                      ]),
                      _c(
                        "div",
                        { staticClass: "metric-icon", class: card.iconClass },
                        [
                          card.ringIcon
                            ? _c("img", {
                                staticClass: "ring-icon",
                                attrs: { src: card.ringIcon, alt: "ring" },
                              })
                            : _c("i", { class: card.icon }),
                        ]
                      ),
                    ]),
                  ])
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticStyle: { "margin-top": "20px" }, attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 14 } },
            [
              _c("customer-collection-chart", {
                attrs: {
                  "customer-data": _vm.customerCollectionData,
                  "daily-data": _vm.dailyCollectionData,
                },
                on: { export: _vm.handleExportCustomerCollection },
              }),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 10 } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 0 } },
                [
                  _c(
                    "el-col",
                    {
                      staticStyle: { "margin-bottom": "20px" },
                      attrs: { span: 24 },
                    },
                    [
                      _c("customer-efficiency-chart", {
                        attrs: { "chart-data": _vm.customerEfficiencyData },
                        on: { export: _vm.handleExportCustomerEfficiency },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("state-efficiency-chart", {
                        attrs: { "chart-data": _vm.stateEfficiencyData },
                        on: { export: _vm.handleExportStateEfficiency },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        {
          staticStyle: { "margin-top": "20px", "margin-bottom": "20px" },
          attrs: { gutter: 20 },
        },
        [
          _c(
            "el-col",
            { attrs: { span: 14 } },
            [
              _c(
                "el-card",
                {
                  staticClass: "chart-card bottom-card",
                  attrs: { shadow: "hover", "body-style": "padding: 20px;" },
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                        "align-items": "center",
                        "font-family": "Alibaba PuHuiTi 2, Alibaba PuHuiTi 20",
                        "font-size": "16px",
                        color: "#0f1728",
                        "font-style": "normal",
                        "text-transform": "none",
                        "font-weight": "bold",
                      },
                      attrs: { slot: "header" },
                      slot: "header",
                    },
                    [
                      _c("span", [
                        _vm._v("揽收异常件 Itens com anomalia na coleta"),
                      ]),
                      _c("img", {
                        staticClass: "export-btn",
                        attrs: { src: _vm.exportIcon, alt: "导出" },
                        on: { click: _vm.handleExportAbnormal },
                      }),
                    ]
                  ),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.loading,
                          expression: "loading",
                        },
                      ],
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.abnormalData,
                        height: "250",
                        "header-cell-style": {
                          background: "#FFFFFF",
                          color: "#666",
                          fontWeight: "normal",
                        },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "index",
                          label: "序号",
                          width: "80",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "reason",
                          label: "异常件原因(Motivo do item com anomalia)",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "problemNum",
                          label: "异常件数量(Qtd. de itens com anomalia)",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "problemRate",
                          label: "异常件占比(Taxa de itens com anomalia)",
                          align: "center",
                          formatter: function (row) {
                            return row.problemRate + "%"
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 10 } },
            [
              _c("personnel-efficiency-stats", {
                attrs: {
                  "cache-time": _vm.cacheTime,
                  data: _vm.humanEfficiencyData,
                },
                on: { export: _vm.handleExportPersonnelEfficiency },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }